module.exports = __webpack_public_path__ + "img/Facebook_f_logo_(2019).17b57389.svg";